// extracted by mini-css-extract-plugin
module.exports = {"container":"UCMovies_container__2QMd-"};